import { Button, Typography } from "@suraasa/placebo-ui"
import { ArrowLeft } from "iconoir-react"

import CarrierTrajectorySection from "./Components/CareerTrajectorySection"
import CaseStudy from "./Components/CaseStudy/CaseStudy"
import ComparisonTable from "./Components/ComparisonTable"
import FormDetails from "./Components/FormDetails"
import SalaryCalculator from "./Components/SalaryCalculator"
import TestimonialCarousel from "./Components/TestimonialCarousel/TestimonialCarousel"

type Props = {
  setCurrentStep: (n: number) => void
}

const Step3 = ({ setCurrentStep }: Props) => {
  return (
    <div className="my-4">
      <Button
        startAdornment={<ArrowLeft />}
        onClick={() => {
          setCurrentStep(2)
        }}
        variant="text"
        className="mb-2"
      >
        Back
      </Button>

      <FormDetails />
      <div className="h-4" />

      <SalaryCalculator />
      <div className="h-2" />

      <CarrierTrajectorySection />
      <div className="h-2" />

      <div className="h-10" />

      <Typography variant="title1" className="text-onSurface-800">
        How an International Teaching Qualification Makes a Difference
      </Typography>
      <div className="h-3" />
      <ComparisonTable />
      <div className="h-10" />
      <Typography variant="title1" className="text-onSurface-800">
        Success Stories of Teachers with International Teacher Qualifications
      </Typography>
      <div className="h-3" />
      <TestimonialCarousel />
      <div className="h-[134px]" />
      <CaseStudy />
    </div>
  )
}

export default Step3
